interface Props {
	data: Record<string, unknown>;
}

export function SeoJsonLd({ data }: Props) {
	return <script type="application/ld+json">{JSON.stringify(data)}</script>;
}
